import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UtilService } from '../../../shared/service/util.service';
import { Observable } from 'rxjs';
import { OperatorList } from '../../operator/models/OperatorList';
import { environment } from '../../../../environments/environment';
import { Filter } from '../../../shared/model/filter';

@Injectable({
  providedIn: 'root'
})
export class BrokerMessagesService {

  constructor(
    private http: HttpClient,
    private utils: UtilService
  ) { }

  getWebPosfMessages(filter: Filter): Observable<any> {
    let params = new HttpParams();
    if (this.utils.nonNullAndNonUndefined(filter.pageOffset)) {
      params = params.append('page', filter.pageOffset);
    }
    if (this.utils.nonNullAndNonUndefined(filter.pageSize)) {
      params = params.append('size', filter.pageSize);
    }
    if (this.utils.nonNullAndNonUndefined(filter.filter)) {
      params = params.append('filter', JSON.stringify(filter.filter));
    }
    if (this.utils.nonNullAndNonUndefined(filter.sort)) {
      params = params.append('sort', filter.sort);
    }
    if (this.utils.nonNullAndNonUndefined(filter.sortDirection)) {
      params = params.append('sortDirection', filter.sortDirection);
    }
    return this.http.get<OperatorList>(environment.baseUrl + `/broker-mesaj/contracte`, { params });
  }

  getMessageDetails(messageId: number): Observable<Object> {
    return this.http.get(environment.baseUrl + `/broker-mesaj/${messageId}`, { responseType: 'text' });
  }
}
